import * as React from "react";
const { isNullOrUndefined } = require("util");

function AbstractMedgoSampleInputLanding({
  label,
  onChange,
  value,
  placeholder,
  centerplaceholder,
  type = "text",
  color = "comet",
  isPassword = false,
  isPasswordVisible = false,
  handleToggleDisplayPassword
}: {
  label: string;
  onChange: (value: string) => void;
  value: string;
  placeholder: string;
  centerplaceholder?: string;
  type?: string;
  color?: string;
  isPassword?: boolean;
  isPasswordVisible?: boolean;
  handleToggleDisplayPassword?: () => void;
}) {
  !isNullOrUndefined(centerplaceholder)
    ? (centerplaceholder = centerplaceholder)
    : (centerplaceholder = "");
  return (
    <div>
      <p className={"text-open-sans input-medgo-label is-landing is-large " + color}>{label}</p>
      {!isPassword && (
        <input
          type={type}
          className={"input-medgo comet" + centerplaceholder}
          onChange={e => {
            //@ts-ignore
            onChange(e.target.value);
          }}
          value={value}
          placeholder={placeholder}
        />
      )}
      {isPassword && (
        <div className="input-group">
          <input
            type={isPasswordVisible ? "text" : "password"}
            className={"input-medgo comet form-control" + centerplaceholder}
            onChange={e => {
              //@ts-ignore
              onChange(e.target.value);
            }}
            value={value}
            placeholder={placeholder}
          />
          <div className="input-group-btn">
            <button className="btn btn-default" type="button" onClick={handleToggleDisplayPassword}>
              <i className={`fa ${isPasswordVisible ? "fa-eye" : "fa-eye-slash"}`} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default AbstractMedgoSampleInputLanding;



// WEBPACK FOOTER //
// ./assets/react/views/abstractPrimitive/AbstractMedgoSampleInputLanding.primitive.tsx